import React from 'react';
import { DollarSign, Hash, TrendingUp, Clock, Percent } from 'lucide-react';

function formatCurrency(value) {
  if (value == null) return '$0';
  return '$' + Number(value).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 });
}

const REPORT_SUMMARIES = {
  sales_pipeline: [
    { key: 'totalCount', label: 'Total Deals', icon: Hash, format: 'number' },
    { key: 'totalAmount', label: 'Pipeline Value', icon: DollarSign, format: 'currency' },
    { key: 'avgDealSize', label: 'Avg Deal Size', icon: TrendingUp, format: 'currency' },
    { key: 'conversionRate', label: 'Win Rate', icon: Percent, format: 'percent' },
    { key: 'avgCycleTime', label: 'Avg Cycle (days)', icon: Clock, format: 'number' },
  ],
  revenue: [
    { key: 'orderCount', label: 'Total Orders', icon: Hash, format: 'number' },
    { key: 'totalRevenue', label: 'Total Revenue', icon: DollarSign, format: 'currency' },
    { key: 'avgOrderValue', label: 'Avg Order Value', icon: TrendingUp, format: 'currency' },
  ],
  forecast: [
    { key: 'dealCount', label: 'Open Deals', icon: Hash, format: 'number' },
    { key: 'totalPipeline', label: 'Total Pipeline', icon: DollarSign, format: 'currency' },
    { key: 'weightedForecast', label: 'Weighted Forecast', icon: TrendingUp, format: 'currency' },
  ],
};

export default function ReportSummary({ reportType, summary }) {
  if (!summary) return null;

  const fields = REPORT_SUMMARIES[reportType] || [];

  return (
    <div className="report-summary-cards">
      {fields.map(({ key, label, icon: Icon, format }) => {
        const value = summary[key];
        let display;
        if (format === 'currency') display = formatCurrency(value);
        else if (format === 'percent') display = `${value || 0}%`;
        else display = String(value || 0);

        return (
          <div key={key} className="report-summary-card">
            <div className="report-summary-card-icon">
              <Icon size={20} />
            </div>
            <div className="report-summary-card-content">
              <div className="report-summary-card-value">{display}</div>
              <div className="report-summary-card-label">{label}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
